import { collectionReducer } from 'utils/reducerGenerator';

export const { reducer, types } = collectionReducer({ namespace: 'CONTACT' });

export default reducer;
